<template>
  <div id="notes">
    <div class="page-title px-4 mb-4">
      <h2>
        <span class="me-2">Notes Management</span>
      </h2>
    </div>
    <v-divider class="mt-4 mb-10"></v-divider>

    <!-- TABS NAVIGATION -->
    <v-tabs v-model="activeTab" background-color="transparent" color="primary">
      <v-tab>
        <v-icon class="me-3">{{ icons.mdiTextBoxMultipleOutline }}</v-icon>
        <span> Notes List </span>
      </v-tab>
      <v-tab>
        <v-icon class="me-3">{{ icons.mdiChartBar }}</v-icon>
        <span> Reporting Breakdown </span>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab" style="background: transparent">
      <v-tab-item>
        <v-card>
          <!-- Mobile Filter Toggle -->
          <v-expansion-panels v-model="filtersExpanded" flat class="d-sm-none mobile-filters">
            <v-expansion-panel>
              <v-expansion-panel-header class="py-2">
                <span class="font-weight-medium">
                  <v-icon left small>{{ icons.mdiFilterVariant }}</v-icon>
                  Filters
                  <v-chip v-if="activeFilterCount > 0" x-small color="primary" class="ml-2">{{
                    activeFilterCount
                  }}</v-chip>
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="pt-2 pb-0 ma-0">
                  <v-col cols="6">
                    <v-select
                      v-model="sqType"
                      :items="typeItems"
                      item-text="text"
                      item-value="value"
                      label="Issue Type"
                      placeholder="Issue Type"
                      outlined
                      hide-details
                      clearable
                      dense
                      class="user-search"
                      @change="val => addToSearchHistory(val, 'sqType')"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="sqStatus"
                      :items="statusItems"
                      item-text="text"
                      item-value="value"
                      label="Status"
                      placeholder="Status"
                      outlined
                      hide-details
                      clearable
                      dense
                      multiple
                      class="user-search"
                      @change="val => addToSearchHistory(val, 'sqStatus')"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="sqPriority"
                      :items="priorityItems"
                      item-text="text"
                      item-value="value"
                      label="Priority"
                      placeholder="Priority"
                      outlined
                      hide-details
                      clearable
                      dense
                      class="user-search"
                      @change="val => addToSearchHistory(val, 'sqPriority')"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="sqAssigned"
                      label="Assigned To"
                      outlined
                      hide-details
                      clearable
                      persistent-clear
                      dense
                      class="user-search"
                      @change="val => addToSearchHistory(val, 'sqAssigned')"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="sqVehicleId"
                      label="Vehicle ID"
                      outlined
                      hide-details
                      clearable
                      persistent-clear
                      dense
                      class="user-search"
                      @change="val => addToSearchHistory(val, 'sqVehicleId')"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="sqDeviceId"
                      label="Device ID"
                      outlined
                      hide-details
                      clearable
                      persistent-clear
                      dense
                      class="user-search"
                      @change="val => addToSearchHistory(val, 'sqDeviceId')"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Desktop Filters (hidden on mobile) -->
          <v-row class="pt-4 pb-0 ma-0 d-none d-sm-flex align-center">
            <v-col class="pa-0">
              <v-row class="ma-0 d-none d-sm-flex">
                <v-col cols="12" sm="3">
                  <v-select
                    v-model="sqType"
                    :items="typeItems"
                    item-text="text"
                    item-value="value"
                    label="Issue Type"
                    outlined
                    hide-details
                    clearable
                    dense
                    @change="val => addToSearchHistory(val, 'sqType')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-select
                    v-model="sqFaultCategory"
                    :items="faultCategoryItems"
                    item-text="text"
                    item-value="value"
                    label="Fault Category"
                    placeholder="Fault Category"
                    outlined
                    hide-details
                    clearable
                    dense
                    multiple
                    @change="val => addToSearchHistory(val, 'sqFaultCategory')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-select
                    v-model="sqStatus"
                    :items="statusItems"
                    item-text="text"
                    item-value="value"
                    label="Status"
                    placeholder="Status"
                    outlined
                    hide-details
                    clearable
                    dense
                    multiple
                    @change="val => addToSearchHistory(val, 'sqStatus')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-select
                    v-model="sqPriority"
                    :items="priorityItems"
                    item-text="text"
                    item-value="value"
                    label="Priority"
                    placeholder="Priority"
                    outlined
                    hide-details
                    clearable
                    dense
                    @change="val => addToSearchHistory(val, 'sqPriority')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="sqAssigned"
                    label="Assigned To"
                    outlined
                    hide-details
                    clearable
                    persistent-clear
                    dense
                    @change="val => addToSearchHistory(val, 'sqAssigned')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="true"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="sqCreated"
                        label="Created Date"
                        readonly
                        v-bind="attrs"
                        outlined
                        hide-details
                        dense
                        clearable
                        v-on="on"
                        @change="val => addToSearchHistory(val, 'sqCreated')"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="sqCreated" no-title @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="sqStopId"
                    label="Stop ID"
                    outlined
                    hide-details
                    clearable
                    persistent-clear
                    dense
                    @change="val => addToSearchHistory(val, 'sqStopId')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="sqRouteId"
                    label="Route ID"
                    outlined
                    hide-details
                    clearable
                    persistent-clear
                    dense
                    @change="val => addToSearchHistory(val, 'sqRouteId')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="sqVehicleId"
                    label="Vehicle ID"
                    outlined
                    hide-details
                    clearable
                    persistent-clear
                    dense
                    @change="val => addToSearchHistory(val, 'sqVehicleId')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="sqDeviceId"
                    label="Device ID"
                    outlined
                    hide-details
                    clearable
                    persistent-clear
                    dense
                    @change="val => addToSearchHistory(val, 'sqDeviceId')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    v-model="sqCaseId"
                    label="Hardware ID"
                    outlined
                    hide-details
                    clearable
                    persistent-clear
                    dense
                    @change="val => addToSearchHistory(val, 'sqCaseId')"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="auto" class="d-flex flex-column align-stretch" style="gap: 8px">
              <v-btn
                outlined
                color="primary"
                class="text-capitalize bg-white"
                :disabled="selectableNotes.length === 0"
                @click="openMetricsForSelection"
              >
                <v-icon left size="20">{{ icons.mdiChartLine }}</v-icon>
                View Metrics
              </v-btn>
              <v-menu offset-y :close-on-content-click="false" left attach>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="primary" v-bind="attrs" class="text-capitalize bg-white" v-on="on">
                    <v-icon left size="20">{{ icons.mdiViewColumn }}</v-icon>
                    Columns
                    <v-icon right small>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list dense max-height="400" class="overflow-y-auto">
                  <v-list-item
                    v-for="h in desktopNoteHeaders"
                    v-if="h.value !== 'action'"
                    :key="h.value"
                    @click.stop="toggleColumn(h.value)"
                  >
                    <v-list-item-action class="mr-2">
                      <v-simple-checkbox
                        :ripple="false"
                        :value="activeHeaders.includes(h.value)"
                        color="primary"
                        @click.stop="toggleColumn(h.value)"
                      ></v-simple-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ h.text }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
          <!-- Notes Filter fields end -->

          <!-- Notes Table start (NOTE: DO NOT disable must-sort, will break custom sort) -->
          <v-data-table
            v-model="selectedNotes"
            :headers="noteHeaders"
            :items="filteredNotes"
            :sort-by.sync="noteSortBy"
            :sort-desc.sync="noteSortDesc"
            :custom-sort="customSort"
            class="text--primary notes-table"
            item-key="id"
            show-select
            :must-sort="true"
          >
            <template v-slot:item.id="{ item }">
              <router-link
                :to="{ name: 'next-stop-note-config', params: { id: item.id } }"
                class="cursor-pointer text-decoration-none"
              >
                <span class="font-weight-semibold text--primary">{{ item.id }}</span>
              </router-link>
            </template>

            <template v-slot:item.title="{ item }">
              <router-link
                :to="{ name: 'next-stop-note-config', params: { id: item.id } }"
                class="cursor-pointer text-decoration-none"
              >
                <div class="d-flex flex-column">
                  <span class="font-weight-semibold text--primary">{{ item.title }}</span>
                  <span v-if="offlineDurationByNote.get(item.id)" class="text-xs error--text text-no-wrap">
                    Device offline for {{ offlineDurationByNote.get(item.id) }}
                  </span>
                </div>
              </router-link>
            </template>

            <template v-slot:item.stop_id="{ item }">
              <router-link
                v-if="item.stop_id"
                :to="{ name: 'next-stop-stop-config', params: { id: item.stop_id } }"
                class="cursor-pointer text-decoration-none text--primary"
              >
                <v-chip link small>{{ item.stop_id }}</v-chip>
              </router-link>
            </template>

            <template v-slot:item.route_id="{ item }">
              <router-link
                v-if="item.route_id"
                :to="{ name: 'next-stop-route-config', params: { id: item.route_id } }"
                class="cursor-pointer text-decoration-none text--primary"
              >
                <v-chip link small>{{ item.route_id }}</v-chip>
              </router-link>
            </template>

            <template v-slot:item.vehicle_id="{ item }">
              <router-link
                v-if="item.vehicle_id"
                :to="{ name: 'next-stop-vehicle-config', params: { id: item.vehicle_id } }"
                class="cursor-pointer text-decoration-none text--primary"
              >
                <v-chip
                  link
                  small
                  outlined
                  :color="
                    vehicleStatusMap[item.vehicle_id] === 'offline'
                      ? 'error'
                      : vehicleStatusMap[item.vehicle_id] === 'idle'
                      ? 'success'
                      : 'warning'
                  "
                >
                  {{ item.vehicle_id }}
                </v-chip>
              </router-link>
            </template>

            <template v-slot:item.device_id="{ item }">
              <router-link
                v-if="item.device_id"
                :to="{ name: 'next-stop-device-config', params: { id: item.device_id } }"
                class="cursor-pointer text-decoration-none text--primary"
              >
                <v-chip link small>{{ item.device_id }}</v-chip>
              </router-link>
            </template>

            <template v-slot:item.case_id="{ item }">
              <router-link
                v-if="item.case_id && item.device_id"
                :to="{ name: 'next-stop-device-config', params: { id: item.device_id } }"
                class="cursor-pointer text-decoration-none text--primary"
              >
                <v-chip link small>{{ item.case_id }}</v-chip>
              </router-link>
            </template>

            <template v-slot:item.convertCreatedDate="{ item }">
              <router-link
                :to="{ name: 'next-stop-note-config', params: { id: item.id } }"
                class="cursor-pointer text-decoration-none text-no-wrap text--primary"
              >
                <span v-html="convertCreatedDate(item)"></span>
              </router-link>
            </template>

            <template v-slot:item.status="{ item }">
              <span :class="item.status !== 'Closed' ? 'font-weight-bold' : ''">
                {{ item.status }}
              </span>
            </template>

            <template v-slot:item.note_update_count="{ item }">
              <v-chip x-small outlined class="font-weight-bold">
                {{ item.note_update_count || 0 }}
              </v-chip>
            </template>

            <template v-slot:item.duration_minutes="{ item }">
              <span class="text-caption text-no-wrap">
                {{ formatDuration(item.duration_minutes) }}
              </span>
            </template>

            <template v-slot:item.action="{ item }">
              <v-btn icon :to="{ name: 'next-stop-note-config', params: { id: item.id } }">
                <v-icon color="primary" size="20">
                  {{ icons.mdiSquareEditOutline }}
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>

          <CSVExportButton :sort-by="noteSortBy" :sort-desc="noteSortDesc" :items="notes" :column-map="noteColumnMap">
          </CSVExportButton>
        </v-card>

        <NotesForm :notes-data="notesData" :enable-free-creation="true" />
      </v-tab-item>

      <!-- TAB 2: REPORTS & BREAKDOWN -->
      <v-tab-item>
        <v-card class="pa-4 mb-4">
          <!-- Report Filters -->
          <v-row align="center">
            <v-col cols="12" sm="3">
              <v-menu
                v-model="menuReportStart"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="reportStartDate"
                    label="Start Date (Created)"
                    readonly
                    v-bind="attrs"
                    outlined
                    hide-details
                    dense
                    clearable
                    :prepend-inner-icon="icons.mdiCalendar"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="reportStartDate" no-title @input="menuReportStart = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-menu
                v-model="menuReportEnd"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="reportEndDate"
                    label="End Date (Created)"
                    readonly
                    v-bind="attrs"
                    outlined
                    hide-details
                    dense
                    clearable
                    :prepend-inner-icon="icons.mdiCalendar"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="reportEndDate" no-title @input="menuReportEnd = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                v-model="reportStatus"
                :items="statusItems"
                item-text="text"
                item-value="value"
                label="Filter by Status"
                outlined
                hide-details
                clearable
                dense
                multiple
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                v-model="reportTags"
                :items="reportTagOptions"
                item-text="text"
                item-value="value"
                label="Filter by Tags"
                outlined
                hide-details
                clearable
                dense
                multiple
                chips
                small-chips
                deletable-chips
              ></v-select>
            </v-col>
          </v-row>
        </v-card>

        <!-- KPI Cards -->
        <v-row>
          <v-col cols="12" sm="6" md="3" class="flex-grow-1">
            <v-card outlined class="text-center pa-4 h-100">
              <div class="text-overline mb-1 text--secondary">Total Notes</div>
              <div class="text-h3 font-weight-bold primary--text">{{ reportStats.total }}</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="flex-grow-1">
            <v-card outlined class="text-center pa-4 h-100">
              <div class="text-overline mb-1 text--secondary">Open Notes</div>
              <div class="text-h3 font-weight-bold warning--text">{{ reportStats.openCount }}</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="flex-grow-1">
            <v-card outlined class="text-center pa-4 h-100">
              <div class="text-overline mb-1 text--secondary">Closed Notes</div>
              <div class="text-h3 font-weight-bold success--text">{{ reportStats.closedCount }}</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="flex-grow-1">
            <v-card outlined class="text-center pa-4 h-100">
              <div class="text-overline mb-1 text--secondary">Avg Time To Resolve</div>
              <div class="text-h5 font-weight-bold mt-2">{{ formatDuration(reportStats.avgDuration) }}</div>
              <div class="text-caption text--secondary mt-1">Based on closed tickets</div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Breakdowns Row 1 -->
        <v-row class="mt-4">
          <!-- Fault Category Breakdown -->
          <v-col cols="12" md="6">
            <v-card outlined class="pa-5 h-100 d-flex flex-column">
              <h3 class="mb-4 d-flex align-center">Fault Category (All Notes)</h3>
              <div v-if="reportStats.faultCategoryBreakdown.length === 0" class="text-body-2 text--secondary">
                No data available for the selected filters.
              </div>
              <div class="overflow-y-auto pr-2" style="max-height: 350px">
                <div v-for="cat in reportStats.faultCategoryBreakdown" :key="cat.name" class="mb-4">
                  <div class="d-flex justify-space-between text-body-2 mb-1">
                    <span class="font-weight-medium">{{ cat.name }}</span>
                    <router-link
                      :to="{ name: 'next-stop-notes', query: { sqFaultCategory: cat.name } }"
                      class="cursor-pointer text-decoration-none me-2"
                    >
                      {{ cat.count }} tickets ({{ cat.percentage }}%)
                    </router-link>
                  </div>
                  <v-progress-linear :value="cat.percentage" color="error" height="8" rounded></v-progress-linear>
                  <div class="d-flex align-center text-caption text--secondary mt-1">
                    <v-icon size="14" class="me-1">{{ icons.mdiClockOutline }}</v-icon>
                    Avg resolution: {{ cat.avgDuration !== null ? formatDuration(cat.avgDuration) : "—" }}
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>

          <!-- Fault Category by Visited Vehicles (notes ever assigned to Quickstart) -->
          <v-col cols="12" md="6">
            <v-card outlined class="pa-5 h-100 d-flex flex-column">
              <h3 class="mb-4 d-flex align-center">Fault Category (Visited Vehicles)</h3>
              <div v-if="quickstartFaultCategoryBreakdown.length === 0" class="text-body-2 text--secondary">
                No notes assigned to Quickstart for the selected filters.
              </div>
              <div class="overflow-y-auto pr-2" style="max-height: 350px">
                <div v-for="cat in quickstartFaultCategoryBreakdown" :key="cat.name" class="mb-4">
                  <div class="d-flex justify-space-between text-body-2 mb-1">
                    <span class="font-weight-medium">{{ cat.name }}</span>
                    <span class="me-2">{{ cat.count }} tickets ({{ cat.percentage }}%)</span>
                  </div>
                  <v-progress-linear :value="cat.percentage" color="success" height="8" rounded></v-progress-linear>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Breakdowns Row 2 -->
        <v-row class="mt-4">
          <!-- Top Problem Vehicles Breakdown -->
          <v-col cols="12" md="6">
            <v-card outlined class="pa-5 h-100 d-flex flex-column">
              <h3 class="mb-4 d-flex align-center">Top Problem Vehicles</h3>
              <div v-if="reportStats.vehicleBreakdown.length === 0" class="text-body-2 text--secondary">
                No data available for the selected filters.
              </div>
              <div class="overflow-y-auto pr-2" style="max-height: 350px">
                <div v-for="veh in reportStats.vehicleBreakdown" :key="veh.name" class="mb-4">
                  <div class="d-flex justify-space-between text-body-2 mb-1 align-center">
                    <span class="font-weight-medium">
                      {{ veh.name !== "No Vehicle" ? veh.name : "Unassigned/No Vehicle" }}
                    </span>
                    <div class="d-flex align-center">
                      <a v-if="veh.name !== 'No Vehicle'" class="mr-2" @click="filterByVehicle(veh.name)">
                        {{ veh.count }} tickets
                      </a>
                      <span v-else> {{ veh.count }} tickets </span>
                    </div>
                  </div>
                  <v-progress-linear :value="veh.percentage" color="warning" height="8" rounded></v-progress-linear>
                </div>
              </div>
            </v-card>
          </v-col>

          <!-- Assignee Breakdown -->
          <v-col cols="12" md="6">
            <v-card outlined class="pa-5 h-100 d-flex flex-column">
              <h3 class="mb-4 d-flex align-center">Workload by Assignee</h3>
              <div v-if="reportStats.assigneeBreakdown.length === 0" class="text-body-2 text--secondary">
                No data available for the selected filters.
              </div>
              <div class="overflow-y-auto pr-2" style="max-height: 350px">
                <div v-for="assignee in reportStats.assigneeBreakdown" :key="assignee.name" class="mb-4">
                  <div class="d-flex justify-space-between text-body-2 mb-1">
                    <span class="font-weight-medium">{{ assignee.name }}</span>
                    <router-link
                      :to="{ name: 'next-stop-notes', query: { sqAssigned: assignee.name } }"
                      class="cursor-pointer text-decoration-none me-2"
                    >
                      {{ assignee.count }} tickets
                    </router-link>
                  </div>
                  <v-progress-linear :value="assignee.percentage" color="info" height="8" rounded></v-progress-linear>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Fault Categories by Vehicle Matrix -->
        <v-row class="mt-4">
          <v-col cols="12">
            <v-card outlined class="pa-5">
              <h3 class="mb-4 d-flex align-center">Fault Categories by Vehicle</h3>
              <div v-if="faultVehicleMatrix.rows.length === 0" class="text-body-2 text--secondary">
                No data available for the selected filters.
              </div>
              <div v-else class="overflow-x-auto">
                <v-simple-table dense class="fault-vehicle-matrix">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left text-no-wrap">Vehicle ID</th>
                        <th v-for="cat in faultVehicleMatrix.categories" :key="cat" class="text-center">
                          <router-link
                            v-if="cat !== 'Uncategorized'"
                            :to="matrixLink(null, cat)"
                            class="cursor-pointer text-decoration-none text--primary"
                          >
                            {{ cat }}
                          </router-link>
                          <span v-else>{{ cat }}</span>
                        </th>
                        <th class="text-center font-weight-bold">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in faultVehicleMatrix.rows" :key="row.vehicle">
                        <td class="font-weight-medium text-no-wrap">
                          <router-link
                            v-if="row.vehicle !== 'No Vehicle'"
                            :to="matrixLink(row.vehicle, null)"
                            class="cursor-pointer text-decoration-none text--primary"
                          >
                            {{ row.vehicle }}
                          </router-link>
                          <span v-else>Unassigned/No Vehicle</span>
                        </td>
                        <td v-for="cat in faultVehicleMatrix.categories" :key="cat" class="text-center">
                          <router-link
                            v-if="row.counts[cat] && row.vehicle !== 'No Vehicle' && cat !== 'Uncategorized'"
                            :to="matrixLink(row.vehicle, cat)"
                            class="cursor-pointer text-decoration-none text--primary"
                          >
                            {{ row.counts[cat] }}
                          </router-link>
                          <span v-else>{{ row.counts[cat] || "" }}</span>
                        </td>
                        <td class="text-center font-weight-bold">{{ row.total }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="repeated-header">
                        <th class="text-left text-no-wrap">Vehicle ID</th>
                        <th v-for="cat in faultVehicleMatrix.categories" :key="cat" class="text-center">
                          <router-link
                            v-if="cat !== 'Uncategorized'"
                            :to="matrixLink(null, cat)"
                            class="cursor-pointer text-decoration-none text--primary"
                          >
                            {{ cat }}
                          </router-link>
                          <span v-else>{{ cat }}</span>
                        </th>
                        <th class="text-center font-weight-bold">Total</th>
                      </tr>
                      <tr>
                        <td class="font-weight-bold text-no-wrap">Total</td>
                        <td
                          v-for="cat in faultVehicleMatrix.categories"
                          :key="cat"
                          class="text-center font-weight-bold"
                        >
                          {{ faultVehicleMatrix.columnTotals[cat] }}
                        </td>
                        <td class="text-center font-weight-bold">{{ faultVehicleMatrix.grandTotal }}</td>
                      </tr>
                    </tfoot>
                  </template>
                </v-simple-table>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Export Breakdown to CSV -->
        <CSVExportButton
          class="mt-4"
          :sort-by="'id'"
          :items="breakdownExportData"
          :column-map="breakdownColumnMap"
        ></CSVExportButton>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import {
  mdiSquareEditOutline,
  mdiFilterVariant,
  mdiViewColumn,
  mdiCalendar,
  mdiChartLine,
  mdiTextBoxMultipleOutline,
  mdiChartBar,
  mdiClockOutline,
} from "@mdi/js"
import { mapState } from "vuex"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import NotesForm from "./components/NotesForm.vue"
import CSVExportButton from "@/views/next-stop/components/CSVExportButton.vue"
import urlHelpers from "@/mixins/urlHelpers"
import store from "@/store"
import globalHelpers from "@/mixins/globalHelpers"
import { getConfigTags, getNewSsdCreatedMs, isNewSsdTag } from "@/utils/tags"

dayjs.extend(utc)
dayjs.extend(timezone)

// Vehicle and device tags share one filter dropdown, so their values are
// prefixed to keep a tag of the same name on each apart
const VEHICLE_TAG_PREFIX = "vehicle:"
const DEVICE_TAG_PREFIX = "device:"

export default {
  name: "Notes",
  metaInfo: {
    title: "Notes",
  },
  components: {
    CSVExportButton,
    NotesForm,
  },
  mixins: [urlHelpers, globalHelpers],

  setup() {
    return {
      icons: {
        mdiSquareEditOutline,
        mdiFilterVariant,
        mdiViewColumn,
        mdiCalendar,
        mdiChartLine,
        mdiTextBoxMultipleOutline,
        mdiChartBar,
        mdiClockOutline,
      },
    }
  },

  data() {
    return {
      activeTab: 0, // 0 = List, 1 = Reports
      filtersExpanded: undefined,
      selectedNotes: [],

      // List Filters
      sqCreated: "",
      sqClaimant: "",
      sqAssigned: "",
      sqStopId: "",
      sqRouteId: "",
      sqVehicleId: "",
      sqDeviceId: "",
      sqCaseId: "",
      sqType: null,
      sqPriority: null,
      sqStatus: null,
      sqFaultCategory: null,

      // Report Filters
      reportStartDate: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
      reportEndDate: dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
      reportStatus: [],
      reportTags: [],
      menuReportStart: false,
      menuReportEnd: false,

      noteSortBy: "convertCreatedDate",
      noteSortDesc: true, // true for descending order, false for ascending order
      menu: false,
      activeHeaders: [
        "id",
        "title",
        "issue_type",
        "vehicle_id",
        "status",
        "assigned",
        "convertCreatedDate",
        "note_update_count",
        "duration_minutes",
      ],
      // Notes Table Headers
      desktopNoteHeaders: [
        { text: "Note ID", value: "id", sortable: true },
        { text: "Title", value: "title", sortable: true },
        { text: "Type", value: "issue_type", sortable: true },
        { text: "Stop", value: "stop_id", sortable: true },
        { text: "Route", value: "route_id", sortable: true },
        { text: "Vehicle", value: "vehicle_id", sortable: true },
        { text: "Device", value: "device_id", sortable: true },
        { text: "Hardware", value: "case_id", sortable: true },
        { text: "Status", value: "status", sortable: true },
        { text: "Priority", value: "priority", sortable: true },
        { text: "Created By", value: "claimant", sortable: true },
        { text: "Assigned To", value: "assigned", sortable: true },
        { text: "Created", value: "convertCreatedDate", sortable: true },
        { text: "Fault Category", value: "fault_category", sortable: true },
        { text: "Updates", value: "note_update_count", sortable: true },
        { text: "Duration", value: "duration_minutes", sortable: true },
        { text: "", value: "action", sortable: false },
      ],
      mobileNoteHeaders: [
        { text: "Note ID", value: "id", sortable: true },
        { text: "Title", value: "title", sortable: true },
        { text: "Vehicle", value: "vehicle_id", sortable: true },
        { text: "Status", value: "status", sortable: true },
        { text: "", value: "action", sortable: false },
      ],
      priorityItems: [
        { text: "Low", value: "Low" },
        { text: "Medium", value: "Medium" },
        { text: "High", value: "High" },
        { text: "Urgent", value: "Urgent" },
      ],
      typeItems: ["Not Running", "Confirmation Rate", "Observation"],
      statusItems: [
        { text: "Open", value: "Open" },
        { text: "Pending", value: "Pending" },
        { text: "On Hold", value: "On Hold" },
        { text: "Closed", value: "Closed" },
      ],
      faultCategoryItems: [
        "Software/System Issue",
        "GPS/Cellular Dropout",
        "Connectivity Issue",
        "SIM Card Fault",
        "SIM Card Holder Fault",
        "Power/Isolator Issue",
        "Data/Log Gap",
        "No Fault Found / Self Recovered",
        "Self Recovered - Isolated Vehicle",
        "Hardware/System Reset",
        "Physical Damage",
        "Internal Component Failure",
        "Other",
      ],
      // Trip assignment report data, used to cross-reference trips against notes in the
      // breakdown CSV export. Lazily fetched when the Reporting Breakdown tab is opened.
      tripAssignments: [],
      breakdownTripsLoaded: false,
      breakdownColumnMap: [
        { text: "Note ID", value: "id" },
        { text: "Status", value: "status" },
        { text: "Assigned To", value: "assigned" },
        { text: "Fault Category", value: "fault_category" },
        { text: "Vehicle ID", value: "vehicle_id" },
        { text: "Vehicle Visited", value: "vehicle_visited" },
        { text: "Note Created", value: "note_created" },
        { text: "Note Closed", value: "note_closed" },
        { text: "Time to Resolve", value: "time_to_resolve" },
        { text: "Trips Assigned", value: "trips_assigned" },
        { text: "Trips Confirmed", value: "trips_confirmed" },
        { text: "Trips Missed", value: "trips_missed" },
      ],
      noteColumnMap: [
        { text: "Note ID", value: "id" },
        { text: "Title", value: "title" },
        { text: "Type", value: "issue_type" },
        { text: "Stop", value: "stop_id" },
        { text: "Route", value: "route_id" },
        { text: "Vehicle", value: "vehicle_id" },
        { text: "Device", value: "device_id" },
        { text: "Hardware", value: "case_id" },
        { text: "Priority", value: "priority" },
        { text: "Status", value: "status" },
        { text: "Created By", value: "claimant" },
        { text: "Assigned To", value: "assigned" },
        { text: "Created", value: "created", conversionFunc: "formatDateTimeStamp" },
        { text: "Fault Category", value: "fault_category" },
        { text: "Updates", value: "note_update_count" },
        { text: "Duration (mins)", value: "duration_minutes" },
      ],
      notesData: {
        claimant: this.$auth.user.name,
      },
      notesLiveUpdate: null,
    }
  },

  computed: {
    ...mapState({
      devices: state => state.gtfs.devices,
      stops: state => state.gtfs.stops,
      routes: state => state.gtfs.routes,
      notes: state => state.gtfs.notes,
      vehicles: state => state.gtfs.vehicles,
    }),
    selectableNotes() {
      return this.selectedNotes.filter(n => n.device_id)
    },
    activeFilterCount() {
      let count = 0
      if (this.sqType) count += 1
      if (this.sqStatus && this.sqStatus.length) count += 1
      if (this.sqPriority) count += 1
      if (this.sqAssigned) count += 1
      if (this.sqVehicleId) count += 1
      if (this.sqDeviceId) count += 1

      return count
    },
    noteHeaders() {
      if (this.$vuetify.breakpoint.xs) {
        return this.mobileNoteHeaders
      }

      return this.desktopNoteHeaders.filter(h => this.activeHeaders.includes(h.value) || h.value === "action")
    },

    // Standard list filter logic
    filteredNotes() {
      return this.notes.filter(note => {
        let include = true

        if (include && this.sqStopId) include = note.stop_id?.includes(this.sqStopId)
        if (include && this.sqVehicleId) include = note.vehicle_id?.includes(this.sqVehicleId)
        if (include && this.sqRouteId) include = note.route_id?.includes(this.sqRouteId)
        if (include && this.sqDeviceId) include = note.device_id?.includes(this.sqDeviceId)
        if (include && this.sqCaseId) include = note.case_id?.includes(this.sqCaseId)

        if (include && this.sqCreated) {
          const date = dayjs(this.formatDate(note.created), "YYYY-MM-DD, h:mm:ss a")
          include = date.format("YYYY-MM-DD") === this.sqCreated
        }

        if (include && this.sqClaimant) include = note.claimant?.toLowerCase().includes(this.sqClaimant.toLowerCase())
        if (include && this.sqType) include = note.issue_type === this.sqType
        if (include && this.sqFaultCategory && this.sqFaultCategory.length)
          return this.sqFaultCategory.includes(note.fault_category)

        if (include && this.sqAssigned) {
          if (this.sqAssigned === "-") {
            include = note.assigned === null || note.assigned === ""
          } else {
            include = note.assigned?.toLowerCase().includes(this.sqAssigned.toLowerCase())
          }
        }

        if (include && this.sqPriority) include = note.priority === this.sqPriority
        if (include && this.sqStatus && this.sqStatus.length) return this.sqStatus.includes(note.status)

        return include
      })
    },

    // The tags in use across the fleet, as one list of select items grouped
    // under a subheading per tag type, the same shape the trip assignments
    // report uses
    reportTagOptions() {
      const toItems = (records, header, prefix) => {
        const tags = new Set()

        ;(records || []).forEach(record => {
          getConfigTags(record.config).forEach(tag => tags.add(tag))
        })

        const items = [...tags].sort((a, b) => a.localeCompare(b)).map(tag => ({ text: tag, value: `${prefix}${tag}` }))

        return items.length ? [{ header }, ...items] : []
      }

      const vehicleItems = toItems(this.vehicles, "Vehicle Tags", VEHICLE_TAG_PREFIX)
      const deviceItems = toItems(this.devices, "Device Tags", DEVICE_TAG_PREFIX)

      if (vehicleItems.length && deviceItems.length) {
        return [...vehicleItems, { divider: true }, ...deviceItems]
      }

      return [...vehicleItems, ...deviceItems]
    },

    // The selected tags split back out by the type they were picked under
    reportSelectedTags() {
      const vehicle = []
      const device = []

      this.reportTags.forEach(value => {
        if (value.startsWith(VEHICLE_TAG_PREFIX)) {
          vehicle.push(value.slice(VEHICLE_TAG_PREFIX.length))
        } else if (value.startsWith(DEVICE_TAG_PREFIX)) {
          device.push(value.slice(DEVICE_TAG_PREFIX.length))
        }
      })

      return { vehicle, device }
    },

    // Vehicle configs keyed by vehicle id, so the tag filter is one lookup per
    // note rather than a scan of the fleet
    reportVehicleConfigMap() {
      const configsByVehicle = new Map()

      ;(this.vehicles || []).forEach(vehicle => {
        configsByVehicle.set(vehicle.vehicle_id, vehicle.config)
      })

      return configsByVehicle
    },

    // How long the note's device has been offline, keyed by note id, but only
    // where it was already offline when the note was raised and has stayed that
    // way since. A device that dropped off after the note is a newer problem,
    // not the long-running outage this is meant to surface.
    offlineDurationByNote() {
      const statusByDevice = new Map((this.devices || []).map(device => [device.device_id, device.status]))
      const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/
      const now = Date.now()
      const durations = new Map()

      ;(this.filteredNotes || []).forEach(note => {
        const status = statusByDevice.get(note.device_id)

        if (!status || status.status !== "offline" || !status.position_timestamp || !note.created) {
          return
        }

        // The last position report is the best proxy for when the device was
        // last online and working, so for an offline device it is when it
        // dropped off
        const lastSeenMs = status.position_timestamp * 1000
        const createdMs = iso8601Regex.test(note.created)
          ? new Date(note.created).getTime()
          : parseInt(note.created, 10) * 1000

        if (!Number.isFinite(createdMs) || lastSeenMs > createdMs) {
          return
        }

        durations.set(note.id, this.formatDuration(Math.floor((now - lastSeenMs) / 60000)))
      })

      return durations
    },

    // The same, for the device each note is raised against
    reportDeviceConfigMap() {
      const configsByDevice = new Map()

      ;(this.devices || []).forEach(device => {
        configsByDevice.set(device.device_id, device.config)
      })

      return configsByDevice
    },

    // Dedicated filter logic for the Reports Tab
    reportFilteredNotes() {
      let rNotes = this.notes || []

      if (this.reportStartDate) {
        const start = dayjs(this.reportStartDate).startOf("day")
        rNotes = rNotes.filter(n => {
          const d = dayjs(n.created)

          return d.isSame(start) || d.isAfter(start)
        })
      }

      if (this.reportEndDate) {
        const end = dayjs(this.reportEndDate).endOf("day")
        rNotes = rNotes.filter(n => {
          const d = dayjs(n.created)

          return d.isSame(end) || d.isBefore(end)
        })
      }

      if (this.reportStatus && this.reportStatus.length > 0) {
        rNotes = rNotes.filter(n => this.reportStatus.includes(n.status))
      }

      if (this.reportTags && this.reportTags.length > 0) {
        rNotes = rNotes.filter(n => this.noteMatchesTags(n))
      }

      return rNotes
    },

    // Aggregates for the Reports Dashboard
    reportStats() {
      const total = this.reportFilteredNotes.length
      const closedNotes = this.reportFilteredNotes.filter(n => n.status === "Closed")
      const closedCount = closedNotes.length
      const openCount = total - closedCount

      // Calculate Average Duration (only for closed notes)
      let avgDuration = 0
      if (closedCount > 0) {
        const totalMins = closedNotes.reduce((acc, n) => acc + (n.duration_minutes || 0), 0)
        avgDuration = Math.round(totalMins / closedCount)
      }

      // Aggregate Fault Categories (with avg resolution time over closed notes per category)
      const categories = {}
      this.reportFilteredNotes.forEach(n => {
        const cat = n.fault_category || "Uncategorized"
        if (!categories[cat]) categories[cat] = { count: 0, closedCount: 0, durationSum: 0 }
        categories[cat].count += 1
        if (n.status === "Closed") {
          categories[cat].closedCount += 1
          categories[cat].durationSum += n.duration_minutes || 0
        }
      })
      const faultCategoryBreakdown = Object.keys(categories)
        .map(key => {
          const cat = categories[key]

          return {
            name: key,
            count: cat.count,
            percentage: total > 0 ? Math.round((cat.count / total) * 100) : 0,
            avgDuration: cat.closedCount > 0 ? Math.round(cat.durationSum / cat.closedCount) : null,
          }
        })
        .sort((a, b) => b.count - a.count)

      // Aggregate Problem Vehicles
      const vehicles = {}
      this.reportFilteredNotes.forEach(n => {
        const v = n.vehicle_id || "No Vehicle"
        if (!vehicles[v]) vehicles[v] = 0
        vehicles[v]++
      })
      const vehicleBreakdown = Object.keys(vehicles)
        .map(key => {
          const count = vehicles[key]

          return { name: key, count, percentage: total > 0 ? Math.round((count / total) * 100) : 0 }
        })
        .sort((a, b) => b.count - a.count)

      // Aggregate Assignees
      const assignees = {}
      this.reportFilteredNotes.forEach(n => {
        const a = n.assigned || "Unassigned"
        if (!assignees[a]) assignees[a] = 0
        assignees[a]++
      })
      const assigneeBreakdown = Object.keys(assignees)
        .map(key => {
          const count = assignees[key]

          return { name: key, count, percentage: total > 0 ? Math.round((count / total) * 100) : 0 }
        })
        .sort((a, b) => b.count - a.count)

      // Aggregate Priority
      const priorities = {}
      this.reportFilteredNotes.forEach(n => {
        const p = n.priority || "Unassigned"
        if (!priorities[p]) priorities[p] = 0
        priorities[p]++
      })
      const priorityOrderMap = { Urgent: 1, High: 2, Medium: 3, Low: 4, Unassigned: 5 }
      const priorityBreakdown = Object.keys(priorities)
        .map(key => {
          const count = priorities[key]

          return { name: key, count, percentage: total > 0 ? Math.round((count / total) * 100) : 0 }
        })
        .sort((a, b) => (priorityOrderMap[a.name] || 99) - (priorityOrderMap[b.name] || 99))

      return {
        total,
        closedCount,
        openCount,
        avgDuration,
        faultCategoryBreakdown,
        vehicleBreakdown,
        assigneeBreakdown,
        priorityBreakdown,
      }
    },

    // Notes (within the current report filters) that were assigned to Quickstart at some
    // point in their update history, broken down by fault category. The backend supplies
    // `assigned_history` as a comma-separated list of every org a note was assigned to.
    quickstartFaultCategoryBreakdown() {
      const qsNotes = this.reportFilteredNotes.filter(n => (n.assigned_history || "").split(",").includes("Quickstart"))
      const total = qsNotes.length

      const categories = {}
      qsNotes.forEach(n => {
        const cat = n.fault_category || "Uncategorized"
        if (!categories[cat]) categories[cat] = 0
        categories[cat] += 1
      })

      return Object.keys(categories)
        .map(key => {
          const count = categories[key]

          return { name: key, count, percentage: total > 0 ? Math.round((count / total) * 100) : 0 }
        })
        .sort((a, b) => b.count - a.count)
    },

    // Matrix of fault category counts (columns) per vehicle (rows), with row and column
    // totals, built from the notes within the current report filters.
    faultVehicleMatrix() {
      const categorySet = new Set()
      const vehicleMap = {}

      this.reportFilteredNotes.forEach(n => {
        const cat = n.fault_category || "Uncategorized"
        const veh = n.vehicle_id || "No Vehicle"
        categorySet.add(cat)
        if (!vehicleMap[veh]) vehicleMap[veh] = {}
        vehicleMap[veh][cat] = (vehicleMap[veh][cat] || 0) + 1
      })

      const categories = Array.from(categorySet).sort()

      const rows = Object.keys(vehicleMap)
        .map(veh => {
          const counts = vehicleMap[veh]
          const total = categories.reduce((sum, c) => sum + (counts[c] || 0), 0)

          return { vehicle: veh, counts, total }
        })
        .sort((a, b) => b.total - a.total)

      const columnTotals = {}
      let grandTotal = 0
      categories.forEach(c => {
        columnTotals[c] = rows.reduce((sum, r) => sum + (r.counts[c] || 0), 0)
        grandTotal += columnTotals[c]
      })

      return { categories, rows, columnTotals, grandTotal }
    },

    // Trip assignment totals grouped by vehicle, each entry being a single day's totals.
    // Used to tally trips that fall within a note's open/closed window for the CSV export.
    tripsByVehicle() {
      const map = new Map()
      this.tripAssignments.forEach(item => {
        if (!item.vehicle_id) return
        const dayMs = dayjs.tz(item.date, "Pacific/Auckland").startOf("day").valueOf()
        if (!map.has(item.vehicle_id)) map.set(item.vehicle_id, [])
        map.get(item.vehicle_id).push({
          dayMs,
          assigned: item.total_assigned || 0,
          confirmed: item.total_confirmed || 0,
        })
      })

      return map
    },

    // Rows for the Reporting Breakdown CSV export. Cross-references each filtered note
    // against the trip assignment report to count trips that occurred while the note was open.
    breakdownExportData() {
      const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/

      return this.reportFilteredNotes.map(note => {
        const visited = (note.assigned_history || "").split(",").includes("Quickstart")

        // Resolve the note's created timestamp (ISO string or unix seconds) to milliseconds.
        let createdMs = null
        if (note.created) {
          createdMs = iso8601Regex.test(note.created)
            ? new Date(note.created).getTime()
            : parseInt(note.created, 10) * 1000
        }

        // Time to Resolve (minutes) comes straight from the API.
        const durationMins = note.duration_minutes
        const isClosed = note.status === "Closed"

        // Derive the closed timestamp from created + duration. Open notes have no close
        // date, so their trip window extends to "now".
        let closedDisplay = ""
        let windowEndMs = Date.now()
        if (isClosed && createdMs !== null && Number.isFinite(durationMins)) {
          const closedMs = createdMs + durationMins * 60000
          windowEndMs = closedMs
          closedDisplay = new Date(closedMs).toLocaleString("sv")
        }

        // Tally trips for this vehicle that fall within [note created day, window end day].
        let tripsAssigned = 0
        let tripsConfirmed = 0
        if (note.vehicle_id && createdMs !== null) {
          const startDayMs = dayjs.tz(createdMs, "Pacific/Auckland").startOf("day").valueOf()
          const endDayMs = dayjs.tz(windowEndMs, "Pacific/Auckland").endOf("day").valueOf()
          const entries = this.tripsByVehicle.get(note.vehicle_id) || []
          entries.forEach(e => {
            if (e.dayMs >= startDayMs && e.dayMs <= endDayMs) {
              tripsAssigned += e.assigned
              tripsConfirmed += e.confirmed
            }
          })
        }

        return {
          id: note.id,
          status: note.status,
          assigned: note.assigned || "Unassigned",
          fault_category: note.fault_category || "",
          vehicle_id: note.vehicle_id || "",
          vehicle_visited: visited ? "true" : "false",
          note_created: createdMs !== null ? this.formatDate(note.created) : "",
          note_closed: closedDisplay,
          time_to_resolve: Number.isFinite(durationMins) ? durationMins : "",
          trips_assigned: tripsAssigned,
          trips_confirmed: tripsConfirmed,
          trips_missed: Math.max(0, tripsAssigned - tripsConfirmed),
        }
      })
    },

    convertCreatedDate() {
      return function (item) {
        return item.created ? this.formatDate(item.created) : "Unknown"
      }
    },

    vehicleStatusMap() {
      const map = {}
      this.vehicles.forEach(v => {
        map[v.vehicle_id] = v.status.status
      })

      return map
    },
  },

  watch: {
    activeTab(val) {
      // Lazily load the trip assignment data the first time the Reporting Breakdown tab opens.
      if (val === 1 && !this.breakdownTripsLoaded) {
        this.fetchBreakdownTripData()
      }
    },
    reportStartDate() {
      // The trip window starts at each note's created date, so a new start date needs fresh data.
      if (this.activeTab === 1) {
        this.fetchBreakdownTripData()
      }
    },
    "$route.query": function (newQuery) {
      this.sqFaultCategory = newQuery.sqFaultCategory || null
      this.sqAssigned = newQuery.sqAssigned || ""
      this.sqVehicleId = newQuery.sqVehicleId || ""

      // If the URL contains ANY of these specific filters, switch to the List tab
      if (newQuery.sqFaultCategory || newQuery.sqAssigned || newQuery.sqVehicleId) {
        this.activeTab = 0
      }
    },
  },

  created() {
    this.is_loading = true
    Promise.all([store.dispatch("getAllNotes"), store.dispatch("getVehicles")]).finally(() => {
      this.is_loading = false
    })
  },

  methods: {
    // A note's created time in milliseconds. Parsed the same way the report's
    // date filters parse it, falling back to unix seconds for the older shape
    // the breakdown export also guards against.
    noteCreatedMs(note) {
      if (!note.created) {
        return null
      }

      const created = dayjs(note.created)

      return created.isValid() ? created.valueOf() : parseInt(note.created, 10) * 1000
    },

    // Whether a config carries the tag for the purposes of this note. New SSD is
    // dated, so it only counts for notes raised after that drive was swapped --
    // earlier notes are about the old SSD and are not the tag's.
    configMatchesTag(config, selectedTag, note) {
      if (!config || !getConfigTags(config).includes(selectedTag)) {
        return false
      }

      if (!isNewSsdTag(selectedTag)) {
        return true
      }

      const newSsdMs = getNewSsdCreatedMs(config)
      const createdMs = this.noteCreatedMs(note)

      if (newSsdMs === null || createdMs === null) {
        return true
      }

      return createdMs > newSsdMs
    },

    // A note matches when its vehicle carries any of the selected vehicle tags,
    // or its device carries any of the selected device tags
    noteMatchesTags(note) {
      const { vehicle, device } = this.reportSelectedTags
      const vehicleConfig = this.reportVehicleConfigMap.get(note.vehicle_id)
      const deviceConfig = this.reportDeviceConfigMap.get(note.device_id)

      return (
        vehicle.some(tag => this.configMatchesTag(vehicleConfig, tag, note)) ||
        device.some(tag => this.configMatchesTag(deviceConfig, tag, note))
      )
    },

    // Fetches the trip assignment report covering the breakdown's report window through today.
    // The end is "today" rather than the report end date so trips during a note's open period
    // (which can extend past its created date) are captured.
    fetchBreakdownTripData() {
      const start = this.reportStartDate || dayjs().subtract(1, "month").format("YYYY-MM-DD")
      const end = dayjs().format("YYYY-MM-DD")

      return store
        .dispatch("getTripAssignmentReport", {
          start_datetime: start,
          end_datetime: end,
        })
        .then(data => {
          this.tripAssignments = data || []
          this.breakdownTripsLoaded = true
        })
        .catch(() => {
          this.tripAssignments = []
        })
    },

    // Builds a route to the Notes List pre-filtered by vehicle and/or fault category.
    // The $route.query watcher reads these params, applies the filters and switches to
    // the List tab. Pass null for either argument to omit that filter.
    matrixLink(vehicleId, faultCategory) {
      const query = {}
      if (vehicleId) query.sqVehicleId = vehicleId
      if (faultCategory) query.sqFaultCategory = faultCategory

      return { name: "next-stop-notes", query }
    },

    toggleColumn(columnValue) {
      const index = this.activeHeaders.indexOf(columnValue)
      if (index > -1) {
        this.activeHeaders.splice(index, 1)
      } else {
        this.activeHeaders.push(columnValue)
      }
    },

    openMetricsForSelection() {
      const notes = this.selectableNotes
      if (!notes.length) return

      if (notes.length > 50) {
        store.commit("SET_SNACKBAR", {
          text: "Please select 50 or fewer notes to view metrics.",
          color: "error",
        })

        return
      }

      const byDevice = {}
      const allTimestamps = []
      notes.forEach(n => {
        const ts = dayjs.tz(n.created, "Pacific/Auckland").valueOf()
        if (!Number.isFinite(ts)) return
        if (!byDevice[n.device_id]) byDevice[n.device_id] = []
        byDevice[n.device_id].push(ts)
        allTimestamps.push(ts)
      })

      if (!allTimestamps.length) return

      const earliest = Math.min(...allTimestamps)
      const latest = Math.max(...allTimestamps)
      const start = dayjs(earliest).tz("Pacific/Auckland").subtract(6, "hour").format("YYYY-MM-DDTHH:mm")
      const end = dayjs(latest).tz("Pacific/Auckland").add(3, "hour").format("YYYY-MM-DDTHH:mm")

      const deviceIds = Object.keys(byDevice)
      const notesParam = deviceIds.map(id => `${id}:${byDevice[id].join(",")}`).join(";")

      this.$router.push({
        name: "next-stop-devices",
        query: {
          tab: "metrics",
          deviceIds: deviceIds.join(","),
          start,
          end,
          notes: notesParam,
        },
      })
    },

    customSort(items, sortBy, sortDesc) {
      const sortByField = sortBy[0] ?? ""
      const sortDescending = sortDesc[0] ?? false

      items.sort((a, b) => {
        let sortA = null
        let sortB = null

        switch (sortByField) {
          case "convertCreatedDate": {
            sortA = new Date(a?.created)
            sortB = new Date(b?.created)
            break
          }
          case "priority": {
            const priorityOrder = { urgent: 1, high: 2, medium: 3, low: 4 }
            sortA = priorityOrder[a.priority?.toLowerCase()] ?? 5
            sortB = priorityOrder[b.priority?.toLowerCase()] ?? 5
            break
          }
          default: {
            sortA = a[sortBy]
            sortB = b[sortBy]
            break
          }
        }

        if (sortA < sortB) return -1
        if (sortA > sortB) return 1

        return 0
      })

      if (sortDescending) items.reverse()

      return items
    },
    getRouteTitle(routeId) {
      const route = this.routes.find(r => r.route_id === parseInt(routeId, 10))

      return route && route.route_short_name && route.route_long_name
        ? `${route.route_short_name} - ${route.route_long_name}`
        : "Unknown"
    },
    getStopTitle(stopId) {
      const stop = this.stops.find(s => s.stop_id === stopId)

      return stop && stop.stop_code && stop.stop_name ? `${stop.stop_code} - ${stop.stop_name}` : "Unknown"
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-filters {
  .v-expansion-panel-header {
    min-height: 48px;
  }
  .v-expansion-panel-content__wrap {
    padding: 0 16px 16px;
  }
}
.h-100 {
  height: 100%;
}

// Repeated header row in the matrix footer: match Vuetify's thead styling so it reads
// as a header rather than a body row.
.fault-vehicle-matrix ::v-deep tfoot tr.repeated-header th {
  height: 48px;
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}

@media (max-width: 599.98px) {
  .notes-table ::v-deep .v-data-table__wrapper .v-data-table__mobile-row {
    min-height: 32px;
  }
}
</style>
